import { Link } from 'react-router-dom';
import { BRAND } from '../config/brand';
import './SiteHeader.css';

function SiteHeader() {
  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Link to="/" className="site-brand" aria-label={`${BRAND.name} home`}>
          <i className="fas fa-crown site-brand-icon" aria-hidden="true"></i>
          <div className="site-brand-text">
            <span className="site-brand-name">{BRAND.name}</span>
            <span className="site-brand-tagline">Domains and ICP landing templates</span>
          </div>
        </Link>
      </div>
    </header>
  );
}

export default SiteHeader;
